import React, { Fragment, useMemo, useState } from 'react';
import { Button, Card, InputNumber, Table, Tag } from 'antd';
import 'antd/dist/antd.css';
import { currencyVND, formatCurrency, parserNumber } from '../../../../../utils';
import InfoRow from '../../../../../components/common/info-row';
import SelectIMEI from './SelectIMEI';

let currIdx = -1;
const ReturnProduct = (props) => {
	const { products, setProducts, totalRefund } = props;
	const [selectedProduct, setSelectedProduct] = useState({});
	const [curRefundProduct, setCurRefundProduct] = useState({});

	const [visible, setVisible] = React.useState(false);

	const handleQuantityChange = (value, record, key) => {
		record[key] = value;
		setProducts([...products]);
	};


	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => index + 1
		},
		{
			title: 'Tên sản phẩm',
			dataIndex: 'productName',
			width: 150
		},
		{
			title: 'Đơn vị',
			dataIndex: 'unitName',
			width: 100,
			align: 'center'
		},
		{
			title: 'Số lượng',
			dataIndex: 'quantity',
			align: 'center',
			width: 100,
			render: (text, record, idx) => {
				const quantity = record.isNormal ? record.quantity : record.imeis.length;
				return <Fragment>
					{record.isNormal ? <InputNumber
						style={{ width: '80%' }}
						min={0}
						formatter={formatCurrency}
						parser={parserNumber}
						max={record.imeis ? record.imeis.length : record.quantity}
						value={record.refundQuantity}
						disabled={!selectedProduct[record.productId]}
						onChange={(value) => handleQuantityChange(value, record, 'refundQuantity')}
					/> : record?.refundQuantity || 0} / {formatCurrency(quantity)}
					{!record.isNormal && <Fragment><br />
						<Button type={'link'} disabled={!selectedProduct[record.productId]} onClick={() => {
							setCurRefundProduct(record);
							setVisible(true);
							currIdx = idx;
						}}> <span style={{ fontSize: '12px' }}>Xem/Chọn IMEI</span></Button></Fragment>}
				</Fragment>;
			}
		},
		{
			title: 'Đơn giá gốc',
			dataIndex: 'unitPrice',
			render: price => currencyVND(price),
			width: 150,
			align: 'center'
		},
		// {
		// 	title: 'Chiết khấu',
		// 	dataIndex: 'discount',
		// 	render: price => currencyVND(price),
		// 	width: 120,
		// 	align: 'center'
		// },
		{
			title: 'Đơn giá trả',
			width: 170,
			render: (text, record) => (<>
					<InputNumber
						min={0}
						step={10000}
						style={{ width: '80%' }}
						formatter={formatCurrency}
						parser={parserNumber}
						value={record.priceRefund}
						disabled={!selectedProduct[record.productId]}
						onChange={(value) => handleQuantityChange(value, record, 'priceRefund')}
					/> VND</>
			),
			align: 'center'
		},
		// {
		// 	title: 'Chiếu khấu',
		// 	width: 170,
		// 	render: (text, record) => (<>
		// 			<InputNumber
		// 				min={0}
		// 				step={10000}
		// 				style={{ width: '80%' }}
		// 				formatter={formatCurrency}
		// 				parser={parserNumber}
		// 				value={record.discount}
		// 				disabled={!selectedProduct[record.productId]}
		// 				onChange={(value) => handleQuantityChange(value, record, 'discount')}
		// 			/> VND</>
		// 	),
		// 	align: 'center'
		// },
		{
			title: 'Thành tiền',
			width: 150,
			align: 'center',
			render: (_, record) => currencyVND(record.priceRefund * record.refundQuantity)
		}
	];

	const totalRefundQuantity = useMemo(() => {
		return products.reduce((acc, item) => acc + item.refundQuantity, 0);
	}, [products]);

	const rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			const map = {};
			products.forEach(item => item.selected = false);
			selectedRows.forEach(item => {
				map[item.productId] = item;
				item.selected = true;
			});
			setSelectedProduct(map);
		}
	};

	const handleSelectImei = (imeiList) => {
		const product = products[currIdx];
		product.imeiListSelected = imeiList;
		product.refundQuantity = imeiList.length;
		setProducts([...products]);
	};

	const expandedRowRender = (record) => {
		const imeiList = record?.imeiListSelected;
		return <Fragment>
			<div style={{ marginLeft: '60px' }}>
				<div className={'mt-20 mb-20'}>
					<i>Danh sách IMEI đã chọn ({imeiList?.length || 0}): </i>{imeiList?.map((el) => <Tag color={'blue'} key={el}>
					{el}
				</Tag>)}
				</div>
			</div>
		</Fragment>;
	};

	const getExpandedRowKeys = () => {
		return products?.filter(el => !el.isNormal).map(el => el.productId) || [];
	};

	return (
		<Card title={'Sản phẩm trả'} className={'mt-20 refund-product-card'}>
			<Table
				rowKey="productId"
				dataSource={products}
				columns={columns}
				pagination={false}
				rowSelection={rowSelection}
				expandIconAsCell={false}
				expandedRowRender={expandedRowRender}
				expandedRowKeys={getExpandedRowKeys()}
				expandIcon={() => ''}
			/>
			<div style={{ marginTop: 16, textAlign: 'left', padding: '10px' }}>
				<InfoRow labelSpan={3} valueSpan={14} label={'Số lượng trả'}
								 value={formatCurrency(totalRefundQuantity) + ' sản phẩm'} />
				{/*<InfoRow labelSpan={3} valueSpan={14} label={'Chiết khấu'} value={currencyVND(discountAmount)} />*/}
				<InfoRow labelSpan={3} valueSpan={14} label={'Cần hoàn tiền trả hàng'}
								 value={<span style={{ color: 'red' }}> {currencyVND(totalRefund)} </span>} />
			</div>
			<SelectIMEI visible={visible} setVisible={setVisible} curProduct={curRefundProduct || {}}
									handleSelectImei={handleSelectImei} />
		</Card>
	);
};

export default ReturnProduct;
